import { capitalize } from 'vue';

import Filter from '@/common/models/query-params/Filter';
import * as FilterComparisonOperator from '@/common/models/query-params/FilterComparisonOperator';
import i18n from '@/vueI18n';

export default class MobileLineItemOptions {
  static DRAFT = 'D';

  static SUBMITTED = 'S';

  static IMAGE = 'I';

  static VIDEO = 'V';

  static LIFETIME = 'L';

  static MONTH = 'M';

  static WEEK = 'W';

  static DAY = 'D';

  static HOUR = 'H';

  static APP = 'app';

  static AWARENESS = 'awareness';

  static OFFLINE = 'offline';

  static ONLINE = 'online';

  static OTHER = 'other';

  static get formatOptions() {
    return [
      {
        name: capitalize(i18n.global.t('names.banner', { n: 1 })),
        value: this.IMAGE,
        $isDisabled: false,
      },
      {
        name: capitalize(i18n.global.t('names.video', { n: 1 })),
        value: this.VIDEO,
        $isDisabled: true,
      },
    ];
  }

  static get goalOptions() {
    return [
      {
        name: capitalize(i18n.global.t('options.goals.raiseAwarenessOfMyBrandOrProduct', { n: 1 })),
        value: this.AWARENESS,
        $isDisabled: false,
      },
      {
        name: capitalize(i18n.global.t('options.goals.driveOnlineActionOrVisits', { n: 1 })),
        value: this.ONLINE,
        $isDisabled: false,
      },
      {
        name: capitalize(i18n.global.t('options.goals.driveOfflineOrInStoreSales', { n: 1 })),
        value: this.OFFLINE,
        $isDisabled: false,
      },
      {
        name: capitalize(i18n.global.t('options.goals.driveAppInstallsOrEngagements', { n: 1 })),
        value: this.APP,
        $isDisabled: false,
      },
      {
        name: capitalize(i18n.global.t('options.goals.other', { n: 1 })),
        value: this.OTHER,
        $isDisabled: false,
      },
    ];
  }

  static get frequencyCapPeriodOptions() {
    return [
      {
        name: capitalize(i18n.global.t('names.lifetime', { n: 1 })),
        value: this.LIFETIME,
      },
      {
        name: capitalize(i18n.global.t('names.month', { n: 1 })),
        value: this.MONTH,
      },
      {
        name: capitalize(i18n.global.t('names.week', { n: 1 })),
        value: this.WEEK,
      },
      {
        name: capitalize(i18n.global.t('names.day', { n: 1 })),
        value: this.DAY,
      },
      {
        name: capitalize(i18n.global.t('names.hour', { n: 1 })),
        value: this.HOUR,
      },
    ];
  }

  static getLocalizedOptionName(name) {
    return capitalize(i18n.global.t(`states.${name}`));
  }

  static statusOptions() {
    return [
      {
        value: 'DRAFT',
        name: MobileLineItemOptions.getLocalizedOptionName('draft'),
        filters: [new Filter('state', [this.DRAFT], FilterComparisonOperator.EQUAL)],
      },
      {
        value: 'SUBMITTED',
        name: MobileLineItemOptions.getLocalizedOptionName('submitted'),
        filters: [new Filter('state', [this.SUBMITTED], FilterComparisonOperator.EQUAL)],
      },
    ].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  }
}
